/**
 * Derives chrome bare-mode from Vike pageContext.urlLogical.
 * LP routes (`/lp/...`) hide header/footer.
 */

export function isBareFromUrlLogical(urlLogical: string | undefined | null): boolean {
  return typeof urlLogical === 'string' && urlLogical.startsWith('/lp/');
}
